import React from 'react'
import { Model, WhenModel } from '@morningtrain/react-resources'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import ImpersonateActions from 'pages/app/users/partials/ImpersonateActions'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { Link } from '@morningtrain/react-navigation'
import { Translation, Translator } from '@morningtrain/react-translations'
import { WhenModelValue } from '@morningtrain/react-resources'

export default function ViewUserSmartview (props) {
  const header = (
    <UI.EmployeeInfo
      width=''
      large
      avatar={<Displays.Image name='avatar_url' />}
      title={<Displays.Text name='name' />}
      text={<Displays.Text name='employment_name' />}
      badges={<Displays.Badges big />}
    />
  )

  const footer = (
    <UI.ButtonWrap>
      <Link route='app.users.edit' parameters={{ user: props.id }}>
        <UI.Button>
          <Translation name='actions.view' />
        </UI.Button>
      </Link>
      <ImpersonateActions id={props.id} />
    </UI.ButtonWrap>
  )

  return (
    <Translator namespace='hr.users'>
      <Model resourceName='users.users' namespace='api' id={props.id}>
        <Smartview header={header} footer={footer} size='sm'>
          <WhenModel>
            <SmartviewTextGroup>
              <SmartviewText label={<Translation name='fields.name.label' />}>
                <Displays.Text name='name' />
              </SmartviewText>
              <SmartviewText label={<Translation name='fields.primary_department.label' />}>
                <Displays.Text name='department.name' />
              </SmartviewText>
              <SmartviewText label={<Translation name='fields.employment_type.label' />}>
                <Displays.Text name='employment_name' />
              </SmartviewText>
              <SmartviewText label={<Translation name='fields.role.label' />}>
                <Displays.Text name='role_name' />
              </SmartviewText>
              <SmartviewText label='Email'>
                <Displays.Text name='email' />
              </SmartviewText>
              <WhenModelValue name='last_login_at'>
                <SmartviewText label={<Translation name='fields.last_login_at.label' />}>
                  <Displays.DateTime name='last_login_at' />
                </SmartviewText>
              </WhenModelValue>
              <WhenModelValue name='last_login_at' negate>
                <SmartviewText label={<Translation name='fields.last_login_at.label' />}>
                  N/A
                </SmartviewText>
              </WhenModelValue>
            </SmartviewTextGroup>
          </WhenModel>
        </Smartview>
      </Model>
    </Translator>
  )
}
